import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import { usePhieuThuContext } from '../context';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onPrintClick?: () => void;
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onMultiPrintClick?: () => void;
  onDownloadExcelTemplateClick?: () => void;
  onImportFromExcelClick?: () => void;
  isEditDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isCopyDisabled?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onPrintClick,
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onMultiPrintClick,
  onDownloadExcelTemplateClick,
  onImportFromExcelClick,
  isEditDisabled = true,
  isDeleteDisabled = true,
  isCopyDisabled = true
}) => {
  const { exportToExcel, canExport, isExporting } = usePhieuThuContext();

  return (
    <AritoActionBar titleComponent={<h1 className='text-xl font-bold'>Phiếu thu tiền</h1>}>
      <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAddClick} variant='secondary' />
      <AritoActionButton
        title='Sửa'
        icon={Pencil1Stroke}
        onClick={onEditClick}
        variant='secondary'
        disabled={isEditDisabled}
      />
      {onDeleteClick && (
        <AritoActionButton
          title='Xóa'
          icon={Trash3Stroke}
          onClick={onDeleteClick}
          variant='secondary'
          disabled={isDeleteDisabled}
        />
      )}
      {onCopyClick && (
        <AritoActionButton
          title='Sao chép'
          icon={FileMultipleStroke}
          onClick={onCopyClick}
          variant='secondary'
          disabled={isCopyDisabled}
        />
      )}
      {onPrintClick && (
        <AritoActionButton title='In ấn' icon={PrinterStroke} onClick={onPrintClick} variant='secondary' />
      )}
      {onSearchClick && (
        <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearchClick} variant='secondary' />
      )}
      <AritoMenuButton
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick,
            group: 0
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: onMultiPrintClick,
            group: 1
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: onDownloadExcelTemplateClick,
            group: 2
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcelClick,
            group: 2
          }
        ]}
      />
    </AritoActionBar>
  );
};
